import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class UsernameGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): boolean {
    const username = localStorage.getItem("username"); // or get from a service
    const userid = localStorage.getItem("user_id"); // or get from a service

    if (username === "demo" || userid == "91") {
      alert("Access denied for demo user");
      this.authService.logout();

      this.router.navigate(["/login"]); // redirect if needed
      return false;
    }

    return true;
  }
}
